module.exports = __webpack_public_path__ + "static/media/IMG_0644.cc39a4a4.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/modra/IMG_0644.JPG
// module id = 90
// module chunks = 0